import * as React from 'react';
import { useFormValue } from './FormContext';

interface FieldProps<T, K extends keyof T> {
    name: K;
    children: (value: T[K], setValue: (val: T[K]) => any) => React.ReactNode;
}

export function Field <T, K extends keyof T> ({ name, children }: FieldProps<T, K>): React.ReactElement {
    const [value, setValue] = useFormValue<T, K>(name);

    return (
        <>
            {children(value, setValue)}
        </>
    );
};
